export default __webpack_public_path__ + "static/media/Belt of the Warded Brute.4ebe0869.jpg";